import { howlMapper } from 'config/constants/audio'
import { InhouseGameDetails } from 'config/types/game'
import React, { useEffect, useMemo, useState } from 'react'
import { StyledInhouseGameContainer } from '../components/styled'
import { GameInHouseConfig } from '../config/types'
import { useInhouseSession } from '../Plinko/hooks'
import DiceBetSettings from './components/BetBoard'
import GameBoard from './components/GameBoard'
import { DiceGameTargetType, diceGameReturnToPlayer, multiplierMax, multiplierMin } from './config'
import { getDicePayoutConfig } from './config/utils'

const DiceGame: React.FC<GameInHouseConfig & { game: InhouseGameDetails }> = ({ volumeEnable, game, ...config }) => {
  const [isLocked, setIsLocked] = useState(false)
  const [target, setTarget] = useState((100 - diceGameReturnToPlayer / 2).toString())
  const [targetType, setTargetType] = useState(DiceGameTargetType.Over)

  useEffect(() => {
    // Init audio
    // eslint-disable-next-line no-unused-expressions
    howlMapper.DicePlaying
    // eslint-disable-next-line no-unused-expressions
    howlMapper.DiceTick
    // eslint-disable-next-line no-unused-expressions
    howlMapper.DiceWin
  }, [])

  const { gameSettings } = useInhouseSession({
    game,
  })

  const gameConfig = useMemo(() => getDicePayoutConfig(Number(target), targetType), [target, targetType])

  return (
    <StyledInhouseGameContainer>
      <DiceBetSettings
        setIsLocked={setIsLocked}
        isLocked={isLocked}
        volumeEnable={volumeEnable}
        target={Number(target)}
        targetType={targetType}
        disabled={Number(gameConfig.multiplier) < multiplierMin || Number(gameConfig.multiplier) > multiplierMax}
        game={game}
        gameSettings={gameSettings}
        {...config}
        width="100%"
        mt={['16px', '', '', '', '0']}
      />
      <GameBoard
        volumeEnable={volumeEnable}
        game={game}
        target={target}
        disabled={isLocked}
        targetType={targetType}
        setTargetType={setTargetType}
        onTargetChanged={setTarget}
      />
    </StyledInhouseGameContainer>
  )
}

const DiceGameMemorized = React.memo(DiceGame)

export default DiceGameMemorized
